import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      props: {
        multiple: true,
        showing: {
          type: Boolean,
          default: false
        }
      },
      dialogFormVisible: false,
      valuearray: [],
      formData: {
        id: '',
        title: "",
        description: "",
        listorder: 100,
        status: 1
      },
      options: [],
      rules: {
        title: [{
          required: true,
          message: "请输入角色名称",
          trigger: "blur"
        }],
        description: [{
          required: true,
          message: "请输入角色描述",
          trigger: "blur"
        }],
        status: [{
          required: true,
          message: "请选择状态",
          trigger: "blur"
        }]
      }
    };
  },
  mounted: function mounted() {},
  created: function created() {},
  methods: {
    format: function format(data) {
      var _this = this;

      // 格式化数据格式
      var res = [];
      data.forEach(function (item) {
        var menu = {
          value: item.id,
          label: item.title
        };

        if (item.son && item.son.length > 0) {
          menu.children = _this.format(item.son);
        }

        res.push(menu);
      });
      return res;
    },
    init: function init(id) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$api.ruleRouterList();

              case 2:
                query = _context2.sent;
                _this2.options = _this2.format(query.data);

                _this2.copyPrimitive();

                if (!id) {
                  _context2.next = 7;
                  break;
                }

                return _context2.delegateYield( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var queryupUser, arr, _loop, i;

                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _this2.$api.ruleDetails({
                            id: id
                          });

                        case 2:
                          queryupUser = _context.sent;
                          _this2.formData = _objectSpread({}, queryupUser.data.role_info);
                          arr = [];

                          _loop = function _loop(i) {
                            var myarr = _this2.deepFind(_this2.options, function (item, index, level) {
                              return item.value === queryupUser.data.auth_me[i];
                            }, "children");

                            arr.push(myarr.map(function (_) {
                              return _.value;
                            }));
                          };

                          for (i = 0; i < queryupUser.data.auth_me.length; i++) {
                            _loop(i);
                          }

                          _this2.valuearray = arr;

                        case 8:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })(), "t0", 7);

              case 7:
                _this2.copyData();

                _this2.dialogFormVisible = true;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      this.valuearray = [];
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var data = JSON.parse(JSON.stringify(_this3.formData));

                    var _arr = Array.from(new Set(_this3.valuearray));

                    console.log(_arr);
                    var reqFn = data.id ? 'updRule' : 'addRule';
                    data.permission_group = _arr.toString(), console.log(data.permission_group);

                    _this3.$api[reqFn](data).then(function (res) {
                      if (res.status == 200) {
                        _this3.$message.success('设置成功');

                        _this3.$emit("change");

                        _this3.dialogFormVisible = false;
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    deepFind: function deepFind(arr, condition, children) {
      // 即将返回的数组
      var main = []; // 用try方案方便直接中止所有递归的程序

      try {
        // 开始轮询
        (function poll(arr, level) {
          // 如果传入非数组
          if (!Array.isArray(arr)) return; // 遍历数组

          for (var i = 0; i < arr.length; i++) {
            // 获取当前项
            var item = arr[i]; // 先占位预设值

            main[level] = item; // 检验是否已经找到了

            var isFind = condition && condition(item, i, level) || false; // 如果已经找到了

            if (isFind) {
              // 直接抛出错误中断所有轮询
              throw Error; // 如果存在children，那么深入递归
            } else if (children && item[children] && item[children].length) {
              poll(item[children], level + 1); // 如果是最后一个且没有找到值，那么通过修改数组长度来删除当前项
            } else if (i === arr.length - 1) {
              // 删除占位预设值
              main.length = main.length - 1;
            }
          }
        })(arr, 0); // 使用try/catch是为了中止所有轮询中的任务

      } catch (err) {} // 返回最终数组


      return main;
    }
  }
};